import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import "./footer.css";

import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer>
      <div className="container-fluid">
        <div className="row px-4">
          {/* LEFT COLUMN — LOGO + ABOUT */}
          <div className="col-md-4 footer-column">
            {/* <img
              src="/logo.png"
              alt="logo"
              className="footer-logo"
            /> */}

            <p className="footer-text">
              We stand by your side, providing expert legal guidance and
              unwavering support to protect your rights and ensure justice is
              served.
            </p>

            <div className="social-icons-footer">
              <div>
                <a
                  href="https://www.youtube.com/@shreeprasadparab"
                  className="social-icon-name"
                  rel="noopener noreferrer"
                >
                  <FaYoutube />
                </a>
              </div>

              <div>
                <a
                  href="https://www.facebook.com/share/1B989EEL9k/?mibextid=wwXIfr"
                  className="social-icon-name"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </a>
              </div>

              <div>
                <a
                  href="https://www.instagram.com/videlicetlaw?igsh=ZHR6d3o4aXdlY3o3"
                  className="social-icon-name"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
              </div>

              <div>
                <a
                  href="https://linkedin.com"
                  className="social-icon-name"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div>

            {/* <p className="mt-4 fw-bold text-start">Open hours :</p>
            <p>Monday – Friday : 9:00 AM – 4:00 PM</p> */}
          </div>

          {/* MIDDLE COLUMN — CONTACT */}
          <div className="col-md-4 footer-column">
            <h4 className="footer-title">Contact Us</h4>
            <p className="footer-contact-line">
              <FaPhoneAlt className="footer-contact-icon" />
              +91 9224453365
            </p>

            <p className="footer-contact-line">
              <FaEnvelope className="footer-contact-icon" />
              <Link
                to="mailto:videlicetlaw@gmail.com"
                className="footer-contact-icon-a"
              >
                videlicetlaw@gmail.com
              </Link>
            </p>

            <p className="footer-contact-line">
              <FaMapMarkerAlt className="footer-contact-icon" />
              101, Krishna Leela Building, Kolkhani lane, Ghatkopar East, Mumbai
              – 400 077.
            </p>
            <p className="footer-contact-line">
              <FaMapMarkerAlt className="footer-contact-icon" />
              304, Swagat CHS, Sector – 44, Plot – 84, Seawoods, Navi Mumbai –
              400 706.
            </p>
          </div>

          {/* RIGHT COLUMN — SERVICES */}
          <div className="col-md-4 footer-column">
            <h4 className="footer-title mx-4 px-2">Services</h4>

            <ul className="footer-list">
              <li>
                <Link to="/submenu">Real Estate</Link>
              </li>
              <li>
                <Link to="/submenu">Litigation</Link>
              </li>
              <li>
                <Link to="/submenu">Social</Link>
              </li>
              <li>
                <Link to="/redevelopment">
                  Redevelopment & Self-Redevelopment
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* BOTTOM ROW */}
        <div className="footer-bottom row small px-4">
         <div className="col-6">
           <p>© 2026 Powered by Kalp Technologies. All rights reserved.</p>

         </div>
          <div className="col-6 d-flex justify-content-center">
            <ul className="footer-list d-flex">
              <li>
                <Link to="/privacypolicy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms of Use</Link>
              </li>
             
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
